﻿(function () {
    'use strict';
    var serviceId = 'repository.servicetime';
    angular
        .module('app.services')
        .factory(serviceId, serviceTime);

    serviceTime.$inject = ['common', 'repository.abstract', '$http'];

    function serviceTime(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getOperationTypes = getOperationTypes;
            this.getServiceTimeList = getServiceTimeList;
            this.getApplicationSettingValueByCategory = getApplicationSettingValueByCategory;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getOperationTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetActivityTypesGTIGTO');
        }

        function getServiceTimeList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/SearchServiceTime', model);
        }

        function getApplicationSettingValueByCategory(categoryName) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetApplicationSettingValueByCategory?categoryName=' + categoryName);
        }

        
    }

})();
